import * as React from "react";
import { Link } from "@/components/common/Link";
export default function ReadyForClarity() {
  return <section data-section-id="231257" id="less-paperwork-more-pasture" className="dark bg-primary text-primary-foreground relative w-full overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665539/img/wheat_field_silhouette.png')] bg-bottom bg-no-repeat opacity-10 pointer-events-none" />
      <div className="container mx-auto px-4 relative z-10">
        <div className="mx-auto flex max-w-[800px] flex-col items-center text-center">
          <h2 className="font-default text-3xl font-bold leading-tight tracking-tight text-primary-foreground md:text-[48px] mb-6">
            Ready to spend less time on paperwork?
          </h2>
          <p className="font-default text-base text-primary-foreground/90 md:text-xl mb-10 max-w-2xl">
            Download BarnDesk and start keeping cleaner records today. Free for up to 10 animals — no credit card to start.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 mb-6">
            <Link to="https://apps.apple.com/us/app/barndesk/id6768716555" aria-label="Download BarnDesk on the App Store" className="inline-block transition-transform hover:-translate-y-1">
              <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" className="h-14 w-auto" />
            </Link>
            <Link to="https://play.google.com/store/apps/details?id=com.barndesk.app" aria-label="Get BarnDesk on Google Play" className="inline-flex items-center gap-3 h-14 px-5 rounded-xl bg-black/80 text-white border border-white/10 transition-transform hover:-translate-y-1">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M3.609 1.814L13.792 12 3.609 22.186a.996.996 0 0 1-.609-.92V2.734a1 1 0 0 1 .609-.92zM14.499 12.707l2.302 2.302-10.937 6.333 8.635-8.635zM13.792 12L21.4 16.34a1.001 1.001 0 0 1 0 1.731l-2.527 1.464-5.081-5.081V12zM5.864 1.179l10.937 6.333-2.302 2.302L5.864 1.179z" />
              </svg>
              <div className="flex flex-col leading-tight text-left">
                <span className="text-[10px] uppercase tracking-wide opacity-80">Get it on</span>
                <span className="text-base font-semibold">Google Play</span>
              </div>
            </Link>
          </div>
          <p className="font-default text-sm text-primary-foreground/90">
            At your desk?{" "}
            <Link to="https://app.thebarndesk.com" newTab className="font-semibold text-primary-foreground underline hover:no-underline whitespace-nowrap">
              Open BarnDesk on the web →
            </Link>
          </p>
          <p className="font-default text-sm text-primary-foreground/70 mt-5">
            Less paperwork. More pasture.
          </p>
        </div>
      </div>
    </section>;
}